import sample_1 from './sample_1.png';

export const basicsElementsPlusImpressions = {
    sample_1,
};
